<ng-container>
  <ng-container
    [ngTemplateOutlet]="documentsTemplate"
    [ngTemplateOutletContext]="{ item: documents }"
  ></ng-container>
</ng-container>

<ng-template #documentsTemplate let-item="item">
  <div class="mb-10 attachmentData">
    <ng-container *ngFor="let el of item.items">
      <div class="d-flex align-items-center flex-grow-1 mb-2">
        <div class="symbol symbol-45 bg-transparent flex-shrink-0">
          <span inlineSVG="assets/icons/Icon-paper-clip.svg"></span>
          <!-- <span class="icon-svg" [inlineSVG]="assets/icons/Icon-paper-clip.svg"></span> -->
          <!-- <img [src]="el.svgPath" alt="" /> -->
        </div>
        <div class="d-flex flex-column ml-3 mt-2 mb-2" style="overflow: hidden">
          <a
            href="{{ el.url }}"
            class="font-weight-bold text-dark text-hover-primary"
            target="_blank"
            download
          >
            {{ el.title }}
          </a>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
